export default __webpack_public_path__ + "static/media/Abuget.50287912.woff";